<template>
  <div>
    <spinner-round :isLoading="loading"></spinner-round>
    <div id="adv-wrapper" v-if="adv && !loading">
      <sticky class="page-header page-header--new sticky-page-header" :back-button="true">
        <div slot="left">
          <h1 class="title is-4">
            <span class="is-uppercase">
              ADV N° : {{adv.ref}}
            </span>
            <span class="is-marginless-right is-uppercase" v-if="adv">
              <router-link :to="{'name': 'LotVue', params: {id: adv.lot}}">
                 - Lot {{adv.lot_ref}}
              </router-link>
            </span>
            <span class="is-marginless-right is-uppercase" v-if="adv">
              <router-link :to="{'name': 'ProgramVue', params: {id: adv.program}}">
                 - {{adv.program_name}}
              </router-link>
            </span>
          </h1>
        </div>
        <a v-if="(isAdmin || isSectorManager) && isReserved" @click="upgradeAdv" class="dropdown-item" slot="dropdown-content">
          <span class="icon is-small">
            <i class="fas fa-award"></i>
          </span>
          <span>Passer lot en vente actée</span>
        </a>
        <a v-if="(isAdmin || isSectorManager) && isSold" @click="downgradeAdv" class="dropdown-item" slot="dropdown-content">
          <span class="icon is-small">
            <i class="fas fa-undo"></i>
          </span>
          <span>Repasser en réservation</span>
        </a>
        <a v-if="(isAdmin || isSectorManager)" @click="xlsExportUrl" class="dropdown-item"
           slot="dropdown-content">
          <span class="icon is-small">
            <i class="fas fa-file-export"></i>
          </span>
          <span>Exporter données .XLS</span>
        </a>
        <a v-if="(isAdmin || isSectorManager)" @click="xlsExportUrlLite" class="dropdown-item"
           slot="dropdown-content">
          <span class="icon is-small">
            <i class="fas fa-file-export"></i>
          </span>
          <span>Exporter ADV réduite</span>
        </a>
        <a v-if="(isAdmin || isSectorManager)" @click="xlsExportNote" class="dropdown-item"
           slot="dropdown-content">
          <span class="icon is-small">
            <i class="fas fa-file-export"></i>
          </span>
          <span>Exporter notes de suivi</span>
        </a>
        <a v-if="(isAdmin || isSectorManager) && (isSold || isReserved)" @click="cancelAdv" class="dropdown-item has-text-danger"
           slot="dropdown-content">
          <span class="icon is-small">
            <i class="fas fa-trash-alt"></i>
          </span>
          <span v-if="isSold">Annuler la vente</span>
          <span v-else>Annuler la réservation</span>
        </a>
        <a v-if="isSuperAdmin" @click="removeAdv" class="dropdown-item has-text-danger" slot="dropdown-content">
          <span class="icon is-small">
            <i class="fas fa-ban"></i>
          </span>
          <span>Supprimer ADV</span>
        </a>
      </sticky>
      <div class="is-padding-top is-padding-left-on-btn-actions is-padding-right-on-btn-actions">
        <div class="tabs is-fullwidth has-text-weight-medium has-bg-white"><!--is-separatedUnderlined-->
          <ul class="has-text-weight-medium is-borderless">
            <li :class="{'is-active':$route.name === 'AdvInfos'}">
              <a class="is-uppercase" :class="{'has-bg-light':$route.name === 'AdvInfos'}"
                @click="goToLink('AdvInfos')">Informations vente</a>
            </li>
            <!-- <li :class="{'is-active':['Commercialisation', 'SellerFacturation'].includes($route.name)}"
                v-if="!isSeller && !isManager">
              <a @click="goToLink('Commercialisation')">Commercialisation et facturation</a>
            </li> -->
            <!-- <li :class="{'is-active':displayMenuFeuilleDeRoute || $route.name === 'AdvRecap'}">
              <a @click="goToLink(isAdmin ? 'ContratDeReservation' : 'AdvRecap')">Feuille de route</a>
            </li> -->
            <li :class="{'is-active':displayMenuFeuilleDeRoute}" class="is-border-left">
              <a class="is-uppercase" :class="{'has-bg-light':displayMenuFeuilleDeRoute}"
                @click="goToLink('ContratDeReservation')">Feuille de route</a>
            </li>
            <li :class="{'is-active':$route.name === 'AdvDocuments'}" class="is-border-left">
              <a class="is-uppercase" :class="{'has-bg-light':$route.name === 'AdvDocuments'}"
                @click="goToLink('AdvDocuments')">
                <div v-if="adv && adv.seller_documents && adv.seller_documents.length > 0"
                     :data-badge="adv.seller_documents.length"
                     class="badge has-badge-rounded has-badge-medium has-badge-notification is-padding-right-small">
                  Documents
                </div>
                <span v-else>Documents</span>
              </a>
            </li>
          </ul>
        </div>
        <div v-if="adv.status === 'canceled_by_admin'" class="is-padding-bottom">
          <div class="notification is-warning has-text-centered is-marginless">
            <p class="is-uppercase is-size-7">
              <span class="icon"><i class="fas fa-exclamation-circle"></i></span>
              <span class="has-text-weight-medium">Adv annulée</span>
            </p>
          </div>
        </div>
        <router-view
          :source="adv"
          :saving="saving"
          :lot="lot"
          :program="program"
          :seller="seller"
          :buyer="buyer"
          :co-buyers="coBuyers"
          :source-shares="shares"
          :source-notes="notes"
          :pending-edition="pendingEdition"
          ref="innerComponent"
          @editAdv="editAdv"
          @commit="commitAdv"
          @updateCom="updateCom"
          @saveAdv="saveAdv"
          @backToInitialAdv="backToInitialAdv"
          @backToInitialShares="backToInitialShares">
        </router-view>
        <!--<div v-if="isAdmin && events && events.length > 0">
          <event-tracker-list v-if="isAdmin" :show-list="showLastEvents" :events="lastEvents" :last-event="lastEvent"
                              :show-all="!!fullHistory && !!fullHistory.length"
                              @showAll="getFullHistory"
                              @toggle="showLastEvents = !showLastEvents">
          </event-tracker-list>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import parallel from 'async/parallel'
  import { isEqual, debounce, isObject, cloneDeep } from 'lodash'
  import { DefaultValues, EventTrackerMx, Error } from '../../mixins'
  import { downloadURI, exportXls, exportXlsNote } from '@/utils'

  export default {
    name: 'Adv',
    mixins: [DefaultValues, EventTrackerMx, Error],
    data () {
      return {
        loadContrat: false,
        loading: false,
        saving: false,
        adv: null,
        coBuyers: [],
        lot: null,
        program: null,
        seller: null,
        buyer: null,
        service: this.$api.advService,
        reservationDate: null,
        shares: [],
        notes: [],
        displaycoBuyers: false,
        eventMaxSize: 20,
        pendingEdition: false,
        initialAdv: {},
        downloadURI
      }
    },
    filters: {
      prettyTva (val) {
        return (val * 100) - 100
      }
    },
    beforeRouteLeave (to, from, next) {
      if (this.pendingEdition && this.canEdit) {
        return this.$swal({
          title: 'Souhaitez vous vraiment quitter cette ADV ?',
          text: 'Vous avez effectué des modifications, si vous quittez sans les enregistrer elles ne seront pas enregistrées.',
          confirmButtonText: 'Enregistrer et quitter',
          confirmButtonColor: '#81bc74',
          cancelButtonText: 'Quiter sans enregistrer',
          cancelButtonColor: '#ff0200',
          showCloseButton: true
        }).then(r => {
          if (r.value) {
            this.saveAdv()
            next()
          } else if (r.dismiss === 'cancel') {
            this.backToInitialAdv()
            this.backToInitialShares()
            next()
          }
        })
      } else {
        next()
      }
    },
    computed: {
      ...mapGetters(['currentUserPk', 'isExternal', 'isAdmin', 'isSectorManager', 'isManager', 'isSeller', 'isSuperAdmin']),
      eventEntity () {
        return this.adv
      },
      sellersPk () {
        return this.shares.map(x => x.seller)
      },
      advPk () {
        return this.$route.params.id
      },
      address () {
        if (this.program) return this.program.address
      },
      status () {
        return this.adv.status
      },
      isReserved () {
        return this.status === 'reserved'
      },
      isCanceled () {
        return this.status === 'canceled_by_admin'
      },
      isSold () {
        return this.status === 'sold'
      },
      displayMenuFeuilleDeRoute () {
        let routes = ['ContratDeReservation', 'Commercialisation', 'Financement', 'Notaire', 'VenteActee', 'Livraison', 'ChoixEtTma', 'AppelDeFonds', 'Signature', 'SellerFacturation']
        return routes.includes(this.$route.name)
      },
      advDate () {
        if (this.adv && this.adv.status) {
          if (this.adv.status === 'sold') return this.adv.sale_date
          if (this.adv.status === 'reserved') return this.adv.reservation_date
          if (this.adv.status.includes('canceled')) return this.adv.cancel_date
        }
      },
      canEdit () {
        if (this.seller) {
          return this.isAdmin || this.isManager || this.isSectorManager || this.currentUserPk === this.seller.pk
        } else {
          return this.isAdmin || this.isManager || this.isSectorManager
        }
      },
      events () {
        return this.adv.events
      },
      priceHt () {
        if (this.adv.sale_price_ht_with_discount) return this.adv.sale_price_ht_with_discount
        else if (this.adv.tva && this.adv.sale_price_with_discount) {
          return this.adv.sale_price_with_discount / (1 + (this.adv.tva / 100))
        }
      }
    },
    methods: {
      upgradeAdv () {
        this.adv.status = 'sold'
        this.saveAdv()
      },
      downgradeAdv () {
        this.adv.status = 'reserved'
        this.saveAdv()
      },
      xlsExportUrl () {
        const query = { pk: [this.adv.pk] }
        return exportXls('advs-export', query, true, `ADV-${this.adv.ref}`)
      },
      xlsExportUrlLite () {
        const query = { pk: [this.adv.pk] }
        return exportXls('advs-export-lite', query, true, `ADV-${this.adv.ref}`)
      },
      xlsExportNote () {
        const url = 'advs/' + this.adv.pk + '/notes-exports'
        return exportXlsNote(url, `ADV-${this.adv.ref}-notes-suivi`)
      },
      removeAdv () {
        this.$swal({
          title: 'Suppression ADV',
          text: 'Êtes-vous sur de vouloir supprimer l\'ADV ?',
          confirmButtonText: 'Supprimer'
        }).then(async r => {
          if (r.value) {
            let r = await this.$api.advService.delete(this.advPk)
            if (r && r.status === 200) {
              this.$notify({
                type: 'is-success',
                text: `Adv supprimée`
              })
              this.$router.replace({ name: 'AdvList' })
            } else {
              this.$notify({
                type: 'is-danger',
                text: `Impossible de supprimer cet ADV`
              })
            }
          }
        })
      },
      saveAdv (val) {
        if (val && val.pk) this.adv = val

        if (!this.adv.sale_date || this.adv.sale_date === null || this.adv.sale_date.length === 0) {
          delete this.adv.sale_date
        }
        this.saving = true
        this.service.put(this.advPk, this.adv)
          .then(res => {
            this.adv = Object.assign({}, res.data)
            this.reservationDate = res.data.reservation_date
            this.saving = false
            this.pendingEdition = false
            const coBuyersPk = this.coBuyers.map(x => x.pk)
            if (!isEqual(coBuyersPk, res.data.co_buyers)) {
              this.coBuyers = []
              res.data.co_buyers.forEach(buyerPk => {
                this.getCoBuyer(buyerPk)
              })
            }
            this.$store.commit('setContratDeResa', null)
            this.$notify({
              type: 'is-success',
              text: 'Adv enregistrée'
            })
          })
          .catch(err => {
            this.saving = false
            this.pendingEdition = false
            this.handleError(err)
            console.log(err)
          })
      },
      commitAdv (adv, autosave = false) {
        this.adv = Object.assign({}, adv)
        console.log('adv vue : ' + adv.signature_date)
        if (autosave === true) {
          this.saveAdv()
        } else {
          this.pendingEdition = true
        }
      },
      cancelAdv () {
        let text
        if (this.isSold) {
          text = 'Êtes-vous sur de vouloir annuler la vente ?'
        } else {
          text = 'Êtes-vous sur de vouloir annuler la réservation ?'
        }
        this.$swal({
          title: 'Annulation ADV',
          text
        })
          .then(r => {
            if (r.value) {
              this.$notify({
                type: 'is-success',
                text: `Annulation de la vente en cours...`
              })
              let payload = Object.assign({}, this.adv)
              payload.status = 'canceled_by_admin'
              this.service.put(this.advPk, payload)
                .then(res => {
                  this.getAdv()
                  // this.$router.replace({ name: 'AdvList' })
                })
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      getAdv () {
        this.loading = true
        this.service.getOne(this.advPk).then(res => {
          this.initialAdv = cloneDeep(res.data)
          this.adv = res.data
          this.reservationDate = res.data.reservation_date
          let callbacks = []

          let _this = this

          let fn1 = function (callback) {
            _this.getLot(res.data.lot, callback)
          }
          callbacks.push(fn1)

          let fn2 = function (callback) {
            _this.getProgram(res.data.program, callback)
          }
          callbacks.push(fn2)

          let fn3 = function (callback) {
            _this.getSeller(res.data.seller, callback)
          }
          callbacks.push(fn3)

          let fn4 = function (callback) {
            _this.getBuyer(res.data.buyer, callback)
          }
          callbacks.push(fn4)

          let fn5 = function (callback) {
            _this.getAdvShares(callback)
          }
          callbacks.push(fn5)

          let fn6 = function (callback) {
            _this.getAdvNotes(callback)
          }
          callbacks.push(fn6)

          this.adv.co_buyers.forEach(buyerPk => {
            let coBuyerFn = function (callback) {
              _this.getCoBuyer(buyerPk, callback)
            }
            callbacks.push(coBuyerFn)
          })

          parallel(callbacks, (err, res) => {
            if (err) {
              console.log(err)
            }
            if (this.addContact && this.adv.co_buyers.includes(this.addContact) === false && this.addContact !== this.adv.buyer) {
              this.$api.contactService.getOne(this.addContact).then(r => {
                this.addCoBuyer(r.data)
              })
            }
            this.loading = false
          })
        }).catch(err => {
          console.log(err)
        })
      },
      getLot (lotPk, callback) {
        this.$api.lotService.getOne(lotPk).then(res => {
          this.lot = res.data
          if (callback) {
            callback(null, res.data)
          }
        }).catch(err => {
          console.log(err)
          callback(err)
        })
      },
      getProgram (programPk, callback) {
        this.$api.programService.getOne(programPk).then(res => {
          this.program = res.data
          if (callback) {
            callback(null, res.data)
          }
        }).catch(err => {
          console.log(err)
          callback(err)
        })
      },
      getSeller (sellerPk, callback) {
        this.$api.userService.getOne(sellerPk).then(res => {
          this.seller = res.data
          if (callback) {
            callback(null, res.data)
          }
        }).catch(err => {
          console.log(err)
          callback(err)
        })
      },
      getBuyer (buyerPk, callback) {
        this.$api.contactService.getOne(buyerPk).then(res => {
          this.buyer = res.data
          if (callback) {
            callback(null, res.data)
          }
        }).catch(err => {
          console.log(err)
          callback(err)
        })
      },
      getCoBuyer (buyerPk, callback) {
        this.$api.contactService.getOne(buyerPk).then(res => {
          this.coBuyers.push(res.data)
          if (callback) {
            callback(null, res.data)
          }
        }).catch(err => {
          console.log(err)
          callback(err)
        })
      },
      getAdvShares (callback) {
        this.loading = true
        this.service.getShares(this.advPk).then(res => {
          this.loading = false
          this.shares = res.data
          this.initialShares = cloneDeep(res.data)
          this.$set(this, 'pendingEdition', false)
          if (callback) {
            callback(null, res.data)
          }
        }).catch(e => {
          this.loading = false
        })
      },
      getAdvNotes (callback) {
        this.loading = true
        this.service.getNotes(this.advPk).then(res => {
          this.loading = false
          this.notes = res.data
          this.$set(this, 'pendingEdition', false)
          if (callback) {
            callback(null, res.data)
          }
        }).catch(e => {
          this.loading = false
        })
      },
      addCoBuyer (buyer) {
        this.pendingEdition = true
        this.coBuyers.push(buyer)
        this.adv.co_buyers = this.coBuyers.map(x => {
          if (isObject(x) && 'pk' in x) {
            return x.pk
          } else {
            return x
          }
        })
        // this.commitAdv(this.adv)
      },
      getOnlyAdv () {
        this.loading = true
        this.service.getOne(this.advPk).then(res => {
          this.loading = false
          this.adv = res.data
          if (this.adv.co_buyers && this.adv.co_buyers.length) {
            this.adv.co_buyers.forEach(x => {
              this.getCoBuyer(x)
            })
          }
          this.initialAdv = cloneDeep(res.data)
          this.$set(this, 'pendingEdition', false)
        }).catch(e => {
          this.loading = false
        })
      },
      updateCom () {
        this.getAdvShares()
        this.getOnlyAdv()
      },
      updateTva: debounce(function () {
        let tva = this.adv.tva
        let salePriceTTC = this.adv.sale_price
        let salePriceHT = salePriceTTC / (1 + (tva / 100))
        salePriceHT = salePriceHT.toFixed(2)
        this.adv.sale_price_ht = Math.round(salePriceHT)
        // this.commitAdv(this.adv)
      }, 300),
      goToLink (link) {
        this.$router.push({ name: link, params: { id: this.advPk } })
        // this.$refs.innerComponent.scrollToAdvContent()
      },
      editAdv (val) {
        console.log('editAdv')
        this.$set(this, 'pendingEdition', val)
      },
      backToInitialAdv () {
        console.log('backToInitialAdv')
        this.coBuyers = []
        this.getOnlyAdv()
        this.$set(this, 'pendingEdition', false)
      },
      backToInitialShares () {
        console.log('backToInitialShares')
        this.getAdvShares()
        this.$set(this, 'pendingEdition', false)
      }
    },
    created () {
      this.getAdv()
      // this.$nextTick(() => {
      //   this.getContrat()
      // })
      if ('addContact' in this.$route.query && this.$route.query.addContact.length > 0) {
        this.addContact = this.$route.query.addContact
      }
    }
  }
</script>

<style scoped>
  select.white-select {
    background-color: white !important;
  }

  .badge[data-badge]::after {
    z-index: 1
  }
</style>



// WEBPACK FOOTER //
// src/components/adv/Adv.vue